import React from "react";
import "../mobile.css";

/**
 * Buttons that stay at the bottom of a detail screen, above the bottom tabs and the iPhone
 * home bar (plan section 4). The shell leaves room for it when `jq-has-action-bar` is on the
 * screen's root. Children are the buttons (each `btn btn-lg`); they share the width.
 */
export default function StickyActionBar({ children, testId = "sticky-action-bar" }) {
  return (
    <div className="jq-action-bar" data-testid={testId}>
      <div className="jq-action-bar-inner">{children}</div>
    </div>
  );
}
